export const ActionSuffixes = {
    _SetLoading: '_SetLoading',
    _Set: '_Set',
    _SelectClear: '_SelectClear',
    _SelectSet: '_SelectSet'
};